import ExchangeRatesProvider from '@components/ExchangeRatesProvider'
import { $settings } from '@velasca/utils/globals'

export const withExchangeRates = (WrappedComponent: any) => {
  return function (props: any) {
    return (
      <ExchangeRatesProvider
        currencyFormat={$settings.currency_format}
        defaultCurrency={$settings.currency}
        defaultFormat={$settings[$settings.currency_format]}
        active={$settings.show_multiple_currencies}
      >
        <WrappedComponent {...props} />
      </ExchangeRatesProvider>
    )
  }
}
